import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import './style/OrdersAdminPage.css';
import NavBarAdmin from "./NavBarAdmin";
import config from './config/config';

const { apiUrl2 } = config;
const SESSION_TIMEOUT = 10 * 60 * 1000; // 10 минут

const dataApi = `${apiUrl2}/api/profile/get-profile-data-admin`;
const statusesApi = `${apiUrl2}/api/profile/get-all-statuses`;
const updateServicesApi = `${apiUrl2}/api/user-services/integ`;
const deleteServicesApi = `${apiUrl2}/api/user-services/integ/del`;
const updateStatusApi = `${apiUrl2}/api/profile/update-state`;
const getProfileDataUrl =`${config.apiUrl2}/api/profile/get-profile-data`;
const apiServiceUrl =`${config.apiUrl2}/api/services`;
const apiServiceUrlsave =`${config.apiUrl2}/api/user-services`;

const OrdersAdminPage2 = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [statuses, setStatuses] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState({});
    const [serviceCounts, setServiceCounts] = useState({});
    const [phone, setPhone] = useState("111111"); // ✅ источник телефона

    useEffect(() => {
        // Загружаем список всех доступных услуг
        fetch(apiServiceUrl)
            .then(res => res.json())
            .then(data => setServices(data))
            .catch(err => console.error("Ошибка при получении услуг:", err));
    }, []);
    // Проверка авторизации
    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/panel/admin-panel');
            }
        } else {
            navigate('/panel/admin-panel');
        }
    }, [navigate]);

    const statusTranslations = {
        CREATED: "Создана",
        IN_PROGRESS: "В обработке",
        APPROVED: "Одобрена",
        REJECTED: "Отклонена",
        CANCELLED: "Отменена",
        SIGNED: "Подписана",
        EXPIRED: "Истек срок",
        ARCHIVED: "Архивирована",
        WAITING_PAYMENT: "Ожидает оплаты",
        PAID: "Оплачено",
        NEED_INFO: "Требуется информация"
    };

    // фильтры
    const [filters, setFilters] = useState({
        id: '',
        full_name: '',
        phone_number: '',
        car: '',
        carNumber: '',
        company: '',
        tariff: '',
        createdAt: '',
        status: '',
    });

    const [showAddServices, setShowAddServices] = useState(false);
    const [newServices, setNewServices] = useState([]);
    const [services, setServices] = useState([]);
    const [profileData, setProfileData] = useState(null);
    const [activeCarId, setActiveCarId] = useState(null);
    const [activeProfile, setActiveProfile] = useState(null);

    // Сохранение новых услуг
    const handleToggleNewService = (e, service) => {
        if (e.target.checked) {
            setNewServices(prev => [...prev, { ...service, total_count: 0 }]);
        } else {
            setNewServices(prev => prev.filter(s => s.id !== service.id));
        }
    };

    const handleNewServiceCount = (e, id) => {
        const value = parseInt(e.target.value, 10);
        setNewServices(prev =>
            prev.map(s => s.id === id ? { ...s, total_count: value } : s)
        );
    };

    const handleSaveNewServices = async () => {
        if (!activeProfile) {
            alert("Не выбран профиль для добавления услуг!");
            return;
        }

        if (newServices.length === 0) {
            alert("❌ Выберите хотя бы одну услугу!");
            return;
        }

        const userId = activeProfile.user.id;
        const carId = activeProfile.car.id;

        const payload = {
            id: null,
            userId: userId,
            carId: carId,
            data: newServices.map(s => ({
                id: s.id,
                service_id: s.id,
                service_name: s.name || s.service_name,
                total_count: s.total_count,
                remaining_count: s.total_count,
            })),
            status: "CREATED"
        };

        try {
            const response = await fetch(apiServiceUrlsave, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert("✅ Услуги успешно добавлены!");
                setShowAddServices(false);
                setNewServices([]);
                setActiveProfile(null);
                window.location.reload();
            } else {
                const errText = await response.text();
                alert("❌ Ошибка при сохранении услуг: " + errText);
            }
        } catch (err) {
            console.error("Ошибка при сохранении услуг:", err);
        }
    };


    // Загрузка профиля и услуг
    useEffect(() => {
        if (!phone) return;

        const fetchData = async () => {
            try {
                const res = await fetch(getProfileDataUrl, {
                    headers: {
                        'phone': phone,
                        'User-Agent': 'insomnia/11.1.0'
                    }
                });
                const data = await res.json();
                setProfileData(data);

                const resServices = await fetch(apiServiceUrl);
                const serviceList = await resServices.json();
                setServices(serviceList);

            } catch (error) {
                console.error('Ошибка загрузки данных:', error);
            }
        };

        fetchData();
    }, [phone]);

    const resetFilters = () => {
        setFilters({
            id: '',
            full_name: '',
            phone_number: '',
            car: '',
            carNumber: '',
            company: '',
            tariff: '',
            createdAt: '',
            status: '',
        });
    };

    // фильтрация данных
    const filteredData = data.filter(entry => {
        const createdAtStr = new Date(entry.createdAt).toLocaleString();

        return (
            entry.id?.toString().includes(filters.id) &&
            (entry.user?.full_name || '').toLowerCase().includes(filters.full_name.toLowerCase()) &&
            (entry.user?.phone_number || '').toLowerCase().includes(filters.phone_number.toLowerCase()) &&
            (`${entry.car?.brandId?.name ?? ''} ${entry.car?.modelId?.name ?? ''}`.toLowerCase().includes(filters.car.toLowerCase())) &&
            (entry.car?.carNumber || '').toLowerCase().includes(filters.carNumber.toLowerCase()) &&
            (entry.insuranceCompany?.name || '').toLowerCase().includes(filters.company.toLowerCase()) &&
            (entry.insuranceTariff?.name || '').toLowerCase().includes(filters.tariff.toLowerCase()) &&
            createdAtStr.toLowerCase().includes(filters.createdAt.toLowerCase()) &&
            (entry.status || '').toLowerCase().includes(filters.status.toLowerCase())
        );
    });

    // загрузка заявок
    useEffect(() => {
        fetch(dataApi, {
            headers: {
                'User-Agent': 'insomnia/11.1.0',
                phone: '111111',
            }
        })
            .then(res => res.json())
            .then(fetchedData => {
                setData(fetchedData);
                const counts = {};
                fetchedData.forEach(entry => {
                    if (entry.car?.userServiceEntity?.data?.length > 0) {
                        counts[entry.id] = {};
                        entry.car.userServiceEntity.data.forEach((service, idx) => {
                            counts[entry.id][idx] = service.remaining_count;
                        });
                    }
                });
                setServiceCounts(counts);
            })
            .catch(console.error);
    }, []);

    const toggleRow = async (index) => {
        if (expandedRowIndex === index) {
            setExpandedRowIndex(null);
        } else {
            try {
                const res = await fetch(statusesApi, {
                    headers: { 'User-Agent': 'insomnia/11.2.0' }
                });
                const statusData = await res.json();
                setStatuses(statusData);
                setExpandedRowIndex(index);
            } catch (err) {
                console.error('Ошибка при получении статусов:', err);
            }
        }
    };

    const handleStatusChange = (appId, value) => {
        setSelectedStatus((prev) => ({
            ...prev,
            [appId]: value,
        }));
    };

    const handleSave = async (appId) => {
        const entry = data.find(item => item.id === appId);
        const statusMnemonics = selectedStatus[appId] || entry.status;

        if (!statusMnemonics) return alert('Выберите статус');

        try {
            const response = await fetch(updateStatusApi, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0',
                },
                body: JSON.stringify({
                    statusMnemonics,
                    premiaSumma: entry.premiaSumma,
                    priceAuto: entry.priceAuto,
                    insuranceContractId: entry.insuranceContractId,
                    id: appId
                })
            });

            if (response.ok) {
                alert('✅ Статус и данные успешно обновлены');
                window.location.reload();
            } else {
                alert('Ошибка при обновлении статуса');
            }
        } catch (err) {
            console.error(err);
            alert('Ошибка сети');
        }
    };

    const handleSaveServices = async (entry) => {
        if (!entry.car?.userServiceEntity?.data?.length) return;

        const updatedServices = entry.car.userServiceEntity.data.map((service, idx) => ({
            service_name: service.service_name,
            total_count: service.total_count,
            remaining_count: serviceCounts[entry.id]?.[idx] ?? service.remaining_count,
        }));

        try {
            const response = await fetch(updateServicesApi, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0',
                },
                body: JSON.stringify({
                    id: entry.car.userServiceEntity.id,
                    data: updatedServices,
                }),
            });

            if (response.ok) {
                alert('Услуги успешно сохранены');
                window.location.reload();
            } else {
                alert('Ошибка при сохранении услуг');
            }
        } catch (err) {
            console.error(err);
            alert('Ошибка сети');
        }
    };


    const handleSaveService = async (entry, service, idx) => {
        const remainingCount =
            serviceCounts[entry.id]?.[idx] ?? service.remaining_count;

        const payload = {
            remainingCount: remainingCount,
            integroServiceId: service.id,      // id из массива data
            serviceId: service.service_id      // service_id из массива data
        };

        try {
            const response = await fetch(updateServicesApi, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                window.location.reload();

                // локально обновляем таблицу
                setServiceCounts((prev) => ({
                    ...prev,
                    [entry.id]: {
                        ...prev[entry.id],
                        [idx]: remainingCount,
                    },
                }));

                // обновляем конкретный сервис в состоянии
                setData((prev) =>
                    prev.map((item) => {
                        if (item.id !== entry.id) return item;
                        return {
                            ...item,
                            car: {
                                ...item.car,
                                userServiceEntity: {
                                    ...item.car.userServiceEntity,
                                    data: item.car.userServiceEntity.data.map(
                                        (s, i) =>
                                            i === idx
                                                ? { ...s, remaining_count: remainingCount }
                                                : s
                                    ),
                                },
                            },
                        };
                    })
                );
            } else {
                console.error("Ошибка сохранения услуги:", await response.text());
            }
        } catch (error) {
            console.error("Ошибка при сохранении:", error);
        }
    };

    const handleDeleteService = async (entry, service) => {
        const payload = {
            userServiceId: entry.car.userServiceEntity.id, // id userServiceEntity (у родителя)
            integroServiceId: service.id,                 // id конкретной услуги
            serviceId: service.service_id                 // service_id услуги
        };

        try {
            const response = await fetch(deleteServicesApi, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "User-Agent": "insomnia/11.3.0"
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                alert("✅ Услуга удалена!");
                window.location.reload();
            } else {
                console.error("Ошибка при удалении:", await response.text());
                alert("❌ Ошибка при удалении");
            }
        } catch (error) {
            console.error("Ошибка сети при удалении:", error);
            alert("❌ Ошибка сети");
        }
    };


    if (!data || data.length === 0) return <div className="loading">Загрузка...</div>;

    return (
        <div className="profile-admin-page">
            <NavBarAdmin/>
            <h2>Админ Панель — Страховые Заявки</h2>

            <table className="table">
                <thead>
                <tr className="filters">
                    {['id', 'full_name', 'phone_number', 'car', 'carNumber', 'company', 'tariff', 'createdAt','status'].map((field, i) => (
                        <td key={i}>
                            <input
                                type="text"
                                value={filters[field]}
                                onChange={e => setFilters({ ...filters, [field]: e.target.value })}
                                placeholder={field}
                            />
                        </td>
                    ))}
                    <td>
                        <button onClick={resetFilters}>Очистить</button>
                    </td>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Пользователь</th>
                    <th>Телефон</th>
                    <th>Автомобиль</th>
                    <th>Транспортный номер</th>
                    <th>Компания</th>
                    <th>Тариф</th>
                    <th>Дата</th>
                    <th>Статус</th>
                    <th>Детали</th>
                </tr>
                </thead>
                <tbody>
                {filteredData.map((entry, index) => (
                    <React.Fragment key={index}>
                        <tr className="clickable-row">
                            <td>{entry.id ?? '—'}</td>
                            <td>{entry.user?.full_name ?? '—'}</td>
                            <td>{entry.user?.phone_number ?? '—'}</td>
                            <td>{`${entry.car?.brandId?.name ?? ''} ${entry.car?.modelId?.name ?? ''}`}</td>
                            <td>{entry.car?.carNumber ?? '—'}</td>
                            <td>{entry.insuranceCompany?.name ?? '—'}</td>
                            <td>{entry.insuranceTariff?.name ?? '—'}</td>
                            <td>{new Date(entry.createdAt).toLocaleString()}</td>
                            <td>
                                <span className={`status-badge status-${(entry.status || '').toLowerCase()}`}>
                                    {statusTranslations[(entry.status || '').toUpperCase()] || entry.status}
                                </span>
                            </td>
                            <td>
                                <button className="toggle-btn" onClick={() => toggleRow(index)}>
                                    {expandedRowIndex === index ? 'Скрыть' : 'Подробнее'}
                                </button>
                            </td>
                        </tr>

                        {expandedRowIndex === index && (
                            <tr className="details-row">
                                <td colSpan="10">
                                    <div className="details-content">
                                        <table className="nested-table">
                                            <tbody>
                                            <tr>
                                                <td><strong>Статус:</strong></td>
                                                <td>
                                                    <select
                                                        value={selectedStatus[entry.id] || entry.status}
                                                        onChange={(e) => handleStatusChange(entry.id, e.target.value)}
                                                    >
                                                        {statuses.map((status) => (
                                                            <option key={status.id} value={status.mnemonics}>
                                                                {status.nameRu}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Премия:</strong></td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={entry.premiaSumma ?? ''}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            setData(prev =>
                                                                prev.map(item =>
                                                                    item.id === entry.id ? { ...item, premiaSumma: newValue } : item
                                                                )
                                                            );
                                                        }}
                                                    /> сум
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Цена авто:</strong></td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={entry.priceAuto ?? ''}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            setData(prev =>
                                                                prev.map(item =>
                                                                    item.id === entry.id ? { ...item, priceAuto: newValue } : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Контракт ID:</strong></td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={entry.insuranceContractId ?? ''}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            setData(prev =>
                                                                prev.map(item =>
                                                                    item.id === entry.id ? { ...item, insuranceContractId: newValue } : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <button className="save-btn" onClick={() => handleSave(entry.id)}>Сохранить</button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        {entry.car?.userServiceEntity?.data?.length > 0 && (
                                            <>
                                                <h4 className="nested-title">Услуги автомобиля</h4>
                                                <table className="nested-table">
                                                    <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Название услуги</th>
                                                        <th>Всего</th>
                                                        <th>Осталось</th>
                                                        <th>Действие</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {entry.car.userServiceEntity.data.map((service, i) => (
                                                        <tr key={i}>
                                                            <td>{service.id ?? i + 1}</td>
                                                            <td>{service.service_name}</td>
                                                            <td>{service.total_count}</td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    value={serviceCounts[entry.id]?.[i] ?? service.remaining_count}
                                                                    onChange={(e) => {
                                                                        const newValue = parseInt(e.target.value, 10);
                                                                        if (!isNaN(newValue)) {
                                                                            setServiceCounts(prev => ({
                                                                                ...prev,
                                                                                [entry.id]: {
                                                                                    ...prev[entry.id],
                                                                                    [i]: newValue,
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                    className="number-input"
                                                                />
                                                            </td>

                                                            <td>
                                                                <button
                                                                    className="save-btn"
                                                                    onClick={() => handleSaveService(entry, service, i)}
                                                                >
                                                                    Сохранить
                                                                </button>

                                                                <button
                                                                    className="delete-btn"
                                                                    onClick={() => handleDeleteService(entry, service)}
                                                                >
                                                                    ❌ Удалить
                                                                </button>



                                                            </td>



                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                                <button
                                                    className="order-btn"
                                                    style={{ marginTop: "10px" }}
                                                    onClick={() => {
                                                        setActiveCarId(entry.car.id);
                                                        setActiveProfile(entry); // ✅ сохраняем активный профиль
                                                        setShowAddServices(true);
                                                    }}
                                                >
                                                    ➕ Добавить услугу
                                                </button>


                                                {showAddServices && (
                                                    <div className="add-service-block">
                                                        <h4>Выберите услуги</h4>
                                                        {services.map(service => (
                                                            <div key={service.id} className="service-input-item">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={newServices.some(s => s.id === service.id)}
                                                                    onChange={(e) => handleToggleNewService(e, service)}
                                                                />
                                                                <label>{service.name}</label>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    placeholder="Количество"
                                                                    value={newServices.find(s => s.id === service.id)?.total_count || ""}
                                                                    onChange={(e) => handleNewServiceCount(e, service.id)}
                                                                    disabled={!newServices.some(s => s.id === service.id)}
                                                                />
                                                            </div>
                                                        ))}

                                                        <button
                                                            className="order-btn"
                                                            style={{ marginTop: "10px" }}
                                                            onClick={handleSaveNewServices}
                                                        >
                                                            💾 Сохранить
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            style={{ marginLeft: "10px" }}
                                                            onClick={() => {
                                                                setShowAddServices(false);
                                                                setNewServices([]);
                                                            }}
                                                        >
                                                            ❌ Отмена
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default OrdersAdminPage2;
